export default "__VITE_ASSET__CedlduMB__"